import * as React from 'react';
import { SVGProps } from 'react';

const IconDataNullSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 22a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-9.469a2 2 0 0 1 .264-.992l3.16-6.531A2 2 0 0 1 6.161 4h15.678a2 2 0 0 1 1.737 1.008l3.16 6.53a2 2 0 0 1 .264.993V22ZM4.455 12H8a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h3.545l-2.286-5H6.741l-2.286 5Z"
    />
  </svg>
);
export default IconDataNullSizeL;
